import React from 'react';
import FadeIn from './FadeIn';

const sponsors = [
  { name: 'IICT University', style: {} },
  { name: 'Univ. of Douala', style: {} },
  { name: 'IUT Douala', style: {} },
  { name: 'Univ. of Yaoundé I', style: {} },
  { name: 'ESSEC Business School', style: {} },
];

export default function Sponsors() {
  return (
    <section className="sponsors" id="sponsors">
      <div className="container">
        <FadeIn>
        <div className="sponsors__list">
          {sponsors.map((s) => (
            <span key={s.name} className="sponsors__item" style={s.style}>
              {s.name}
            </span>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
